@if (bannerText) {
    <div
        class="banner fw:semibold bg:blue-700 c:white p-24 align:c"
        [innerHTML]="bannerText"
    ></div>
}
<div class="price-container">
    <div class="price-content">
        <span class="h4 product-hint">{{ settlementPeriod === 'year' ? 'Jährlich' : 'Monatlich' }}</span>
        <ng-content></ng-content>
        <app-display-price [price]="price" />
        <span
            class="product-tax-details"
            [innerHTML]="taxInfo"
        ></span>
    </div>
    @if (buttonText) {
        <button
            type="submit"
            class="-content-width next"
            [disabled]="buttonDisabled"
        >
            {{ buttonText }}
        </button>
    }
</div>
